import React, { Component } from "react";
import FlexView from "react-flexview";
import { connect } from "react-redux";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleLoadingOverlay from "../../../../modules/popup/SimpleLoadingOverlay";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDate from "../../../../modules/SimpleDate";
import SimpleDDL from "../../../../modules/SimpleDDL";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleTextArea from "../../../../modules/simpleTextArea";
import ErrorAction from "../../../../Redux/ErrorRedux";
import Api from "../../../../Services/Api";
import { HttpStatus } from "../../../common/Constants";
import { mapToObjectDDL } from "../../../common/mapper";
import DataKonsumenInputs from "../common/dataKonsumenInputs";
import InfoUnitInputs from "../common/infoUnitInputs";

class IndentUnitSudahProsesDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      data: null,
      varianInformation: {
        name: "-",
        type: "-",
        series: "-",
      },
    };
  }

  async componentDidMount() {
    this.setState((prevValue) => ({ ...prevValue, loading: true }));
    const response = await Api.create("NAGAMAS_TRANSACTION").getIndentUnitDetail(
      this.props.kodeCabang,
      this.props.id
    );
    if (response.data.status === HttpStatus.FAILED) {
      this.props.setError({
        menuName: "Indent Unit Sudah Proses",
        errorMessage: response.data.message,
      });
      this.props.onClickClose();
      return;
    }
    this.setState((prevValue) => ({
      ...prevValue,
      data: {
        ...response.data.data,
        indentDeposit: response.data.data?.indentDeposit ? "Y" : "N",
        paymentPlan: response.data.data?.paymentPlan
          ? mapToObjectDDL(response.data.data.paymentPlan, response.data.data)
          : null,
      },
      varianInformation: {
        name: response.data?.data?.dataVarian.namaVariant || "-",
        type: response.data?.data?.dataVarian.idType || "-",
        series: response.data?.data?.dataVarian.kodeUnitPabrik || "-",
      },
      loading: false,
    }));
  }

  render() {
    return (
      <>
        <SimpleModal
          title="Indent Unit Detail - View"
          visible={!!this.props.id}
          onClickClose={this.props.onClickClose}
          content={
            <ModalContainer>
              <div className="grid grid-2x grid-mobile-none gap-15px">
                <div id="form_grid-1">
                  <SimpleInput
                    id="input_text_no_indent"
                    label="No. Indent"
                    name="noIndent"
                    value={this.state.data?.indentNo}
                    readOnly
                  />
                  <SimpleInput
                    id="input_text_no_prospek"
                    label="No. Prospek (optional)"
                    name="noProspek"
                    value={this.props.controls?.noProspek.value}
                    readOnly
                  />
                </div>
                <div id="form_grid-2">
                  <SimpleDate
                    id="select_date_tgl_indent"
                    disabled
                    date={this.state.data?.indentDate}
                    name="tglIndent"
                    label="Tgl. Indent"
                  />
                  <p>Status : {this.state.data?.indentStatus}</p>
                </div>
              </div>
              <hr style={{ height: "1px", background: "gray", marginBottom: "15px" }} />
              <div className="grid grid-2x grid-mobile-none gap-15px">
                <div id="form_data-grid-1">
                  <DataKonsumenInputs
                    activity="VIEW"
                    data={{
                      customerName: this.state.data?.customerName,
                      memberID: this.state.data?.customerMemberId,
                      customerKTPNumber: this.state.data?.customerKTPNumber,
                      customerHpNumber: this.state.data?.customerHpNumber,
                      customerWaNumber: this.state.data?.customerWaNumber,
                      email: this.state.data?.email,
                      customerAddress: this.state.data?.customerAddress,
                      customerProvinceId:
                        this.state.data?.dataProvinceCustomer &&
                        mapToObjectDDL(
                          this.state.data?.dataProvinceCustomer.provinceName,
                          this.state.data?.dataProvinceCustomer.id
                        ),
                      customerKabKotId:
                        this.state.data?.dataKabKotCustomer &&
                        mapToObjectDDL(
                          this.state.data?.dataKabKotCustomer.kabKotName,
                          this.state.data?.dataKabKotCustomer.kabKotId
                        ),
                      customerKecamatanId:
                        this.state.data?.dataKecamatanCustomer &&
                        mapToObjectDDL(
                          this.state.data?.dataKecamatanCustomer.kecamatanName,
                          this.state.data?.dataKecamatanCustomer.id
                        ),
                      customerKelurahanId:
                        this.state.data?.dataKelurahanCustomer &&
                        mapToObjectDDL(
                          this.state.data?.dataKelurahanCustomer.kelurahanname,
                          this.state.data?.dataKelurahanCustomer.id
                        ),
                      customerZipCode:
                        this.state.data?.dataKelurahanCustomer &&
                        mapToObjectDDL(
                          this.state.data?.dataKelurahanCustomer.zipcode,
                          this.state.data?.dataKelurahanCustomer.zipcode
                        ),
                    }}
                  />
                </div>
                <div id="form_data-grid-2">
                  <InfoUnitInputs
                    activity="VIEW"
                    state={this.state}
                    data={{
                      variantCode:
                        this.state.data?.dataVarian &&
                        mapToObjectDDL(
                          this.state.data?.dataVarian.namaVariant,
                          this.state.data?.dataVarian.kodeVariant
                        ),
                      idWarna:
                        this.state.data?.dataWarna &&
                        mapToObjectDDL(
                          this.state.data?.dataWarna.namaWarnaKomersil,
                          this.state.data?.dataWarna.kodeWarna
                        ),
                    }}
                  />
                  <div>
                    <h4>Pembayaran (Optional)</h4>
                    <SimpleDDL
                      id="select_options_rencana_pembayaran"
                      name="paymentPlan"
                      box="search"
                      label="Rencana Pembayaran Pembelian"
                      isClearable
                      readOnly
                      value={this.state.data?.paymentPlan}
                    />
                    <FlexView vAlignContent="center" style={{ gap: "15px" }}>
                      <p>Tanda Jadi:</p>
                      <div>
                        <input
                          type="radio"
                          id="input_radio_yes"
                          name="indentDeposit"
                          value="Y"
                          disabled
                          checked={this.state.data?.indentDeposit === "Y"}
                        />
                        <label htmlFor="input_radio_yes">Ya</label>
                      </div>
                      <div>
                        <input
                          type="radio"
                          id="input_radio_no"
                          name="indentDeposit"
                          value="N"
                          disabled
                          checked={this.state.data?.indentDeposit === "N"}
                        />
                        <label htmlFor="input_radio_no">No</label>
                      </div>
                    </FlexView>
                    <FlexView vAlignContent="center">
                      <p>Jumlah Tanda Jadi:</p>
                      <p className="margin-left-10px margin-right-5px">Rp.</p>
                      <SimpleInput
                        id="input_text_jumlah_tanda_jadi"
                        name="totalDepositAmount"
                        box="onlyNumber"
                        containerclassname="margin-bottom-none"
                        readOnly
                        value={this.state.data?.totalDepositAmount}
                      />
                    </FlexView>
                  </div>
                  <div>
                    <h4>Pembatalan</h4>
                    <SimpleInput
                      id="input_text_tgl_cancel"
                      name="tglCancel"
                      label="Tgl. Cancel"
                      readOnly
                      value={this.state.data?.dataCancelledIndentUnit?.indentDateCancelled}
                    />
                    <SimpleTextArea
                      id="input_textarea_alasan_cancel"
                      name="alasanCancel"
                      label="Alasan Cancel"
                      readOnly
                      value={this.state.data?.dataCancelledIndentUnit?.indentReasonCancelled}
                    />
                  </div>
                </div>
              </div>
            </ModalContainer>
          }
        />
        {this.state.loading && <SimpleLoadingOverlay active={this.state.loading} />}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setError: (payload) => dispatch(ErrorAction.setError(payload)),
  };
};

export default connect(null, mapDispatchToProps)(IndentUnitSudahProsesDetail);
